import { THERMAL_ZONE_STATUS } from '../../config/status';

import './ThermalZoneStatusPill.scss';

interface ThermalZoneStatusPillProps {
  status: (typeof THERMAL_ZONE_STATUS)[keyof typeof THERMAL_ZONE_STATUS];
  size?: 'small' | 'large';
}

export const ThermalZoneStatusPill = ({ status, size = 'small' }: ThermalZoneStatusPillProps) => {
  return (
    <div
      className={`thermal-zone-status-pill ${status?.cssClass || 'unmanaged'} thermal-zone-status-pill--${size}`}
    >
      <div className="thermal-zone-status-pill--label">{status.label}</div>
    </div>
  );
};
